module.exports = __webpack_public_path__ + "78a2d24d9f66d68dc272d216869d8649.pdf";